import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CtvSabitBilgiGetAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "CtvSabitBilgiGet";
    super(baseUrl);
  }


  getCtvSabitBilgiGet(){

    return this.get();
  }

}
export default new CtvSabitBilgiGetAPI();
